import { render, staticRenderFns } from "./BInput.vue?vue&type=template&id=89b4051c"
import script from "./BInput.vue?vue&type=script&lang=js"
export * from "./BInput.vue?vue&type=script&lang=js"
import style0 from "./BInput.vue?vue&type=style&index=0&id=89b4051c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports